import InviteMediatorListing from "./invitedMediatorList";

export default InviteMediatorListing;
